export class Task {
    ID:number;
    CLIENT_ID:number;
    NAME:string;
    DESCRIPTION:string;
    API_URL:string;
    PARAMETER_FORMAT:string;
    TASK_KEY:string;
}
